import { Component, Input, OnInit } from '@angular/core';
import { AccountDTO, LocationDTO, TripDTO } from '../../interfaces/models';

@Component({
  selector: 'app-driver-details-record',
  templateUrl: './driver-details-record.component.html',
})
export class DriverDetailsRecordComponent implements OnInit {
  @Input() trip: TripDTO;
  @Input() disabled = false;

  driver: AccountDTO;
  avatarUrl: string;
  from: string;
  to: string;
  phoneNumber: string;
  name: string;
  amount: string;
  status: string;

  ngOnInit() {
    this.trip.driver = this.trip.driver || {} as AccountDTO;
    this.driver = this.trip.driver;
    this.name = this.driver.firstName && this.driver.lastName && `${this.driver.firstName} ${this.driver.lastName}` || undefined;
    this.amount = this.trip.totalPrice && this.trip.totalPrice.toFixed(2) || undefined;
    this.avatarUrl = this.driver.avatarUrl;

    this.phoneNumber = this.driver.phoneNumber;
    this.from = this.getLocationFormatted(this.trip.pickLocation);
    this.to = this.getLocationFormatted(this.trip.deliveryLocation);

    this.status = this.trip.status;
  }

  private getLocationFormatted(location: LocationDTO) {
    if (!location) {
      return;
    }
    const {
      city,
      state,
      zipCode,
    } = location;

    return [city, state, zipCode].join(', ');
  }
}
